import { computed, ref, watch } from '@vue/composition-api';
import useAccountTransaction from '@/modules/account/composables/useAccountTransaction';
import useUtils from '@/composables/useUtils';

const useAccountTransactionsHistoryList = (props) => {
  const { fetchAccountTransactions } = useAccountTransaction();
  const { formatDateYyyyMmDd, convertDateToUTC } = useUtils();

  const perPageOptions = [10, 25, 50, 100];
  const tableColumns = [
    { key: 'id', label: '#', sortable: true },
    { key: 'transactionStatusId', label: 'Status' },
    { key: 'accountId', label: 'Account', sortable: true },
    { key: 'taxiId', label: 'Taxi', sortable: true },
    { key: 'bookingId', label: 'Booking', sortable: true },
    { key: 'postId', label: 'Post', sortable: true },
    { key: 'tourId', label: 'Tour', sortable: true },
    { key: 'amount', sortable: true },
    { key: 'transactionDateUtc', label: 'Date', sortable: true },
    { key: 'actions' },
  ];

  const pageNumber = ref(1);
  const orderDesc = ref(true);
  const pageSize = ref(10);
  const refTransactionList = ref(null);
  const totalTansactions = ref(0);
  const orderBy = ref('id');

  const accountFilter = ref(
    localStorage.getItem('accountTransactionHistoryList-accountFilter') == 'null'
      ? null
      : JSON.parse(localStorage.getItem('accountTransactionHistoryList-accountFilter'))
  );
  const transactionStatusFilter = ref(
    localStorage.getItem('accountTransactionHistoryList-transactionStatusFilter') == 'null'
      ? null
      : JSON.parse(localStorage.getItem('accountTransactionHistoryList-transactionStatusFilter'))
  );
  const searchQuery = ref(
    localStorage.getItem('accountTransactionHistoryList-searchQuery') == ''
      ? ''
      : localStorage.getItem('accountTransactionHistoryList-searchQuery')
  );
  const searchByDate = ref(
    localStorage.getItem('accountTransactionHistoryList-searchByDate') == ''
      ? ''
      : localStorage.getItem('accountTransactionHistoryList-searchByDate')
  );

  const dataMeta = computed(() => {
    const localItemsCount = refTransactionList.value
      ? refTransactionList.value.localItems.length
      : 0;
    return {
      from: pageSize.value * (pageNumber.value - 1) + (localItemsCount ? 1 : 0),
      to: pageSize.value * (pageNumber.value - 1) + localItemsCount,
      of: totalTansactions.value,
    };
  });

  watch(
    [pageNumber, pageSize, accountFilter, transactionStatusFilter, searchByDate],
    () => {
      localStorage.setItem(
        'accountTransactionHistoryList-accountFilter',
        JSON.stringify(accountFilter.value)
      );
      localStorage.setItem(
        'accountTransactionHistoryList-transactionStatusFilter',
        JSON.stringify(transactionStatusFilter.value)
      );
      localStorage.setItem(
        'accountTransactionHistoryList-searchByDate',
        searchByDate.value
      );
      refTransactionList.value.refresh();
    }
  );

  const refreshTable = () => {
    localStorage.setItem(
        'accountTransactionHistoryList-searchQuery',
        searchQuery.value
      );
    refTransactionList.value.refresh();
  };

  const clearSearchByDate = () => {
    searchByDate.value = '';
  };

  const getTransactionList = (_, callback) => {
    const params = {
      orderBy: orderBy.value,
      orderDesc: orderDesc.value,
      searchByDate: searchByDate.value === '' ? null : formatDateYyyyMmDd(convertDateToUTC(searchByDate.value)),
      pageSize: pageSize.value,
      pageNumber: pageNumber.value,
      accountId: accountFilter.value?.id ?? undefined,
      transactionStatusId: transactionStatusFilter.value?.id ?? undefined,
      searchQuery: searchQuery.value,
    };

    fetchAccountTransactions(props.accountId, params).then(
      ({ transactions, total }) => {
        callback(transactions);
        totalTansactions.value = total;
      }
    );
  };

  return {
    // Const
    perPageOptions,
    tableColumns,

    // Reactive
    orderBy,
    orderDesc,
    pageNumber,
    pageSize,
    refTransactionList,
    searchQuery,
    accountFilter,
    transactionStatusFilter,
    totalTansactions,
    searchByDate,

    // Computed
    dataMeta,

    // Method
    getTransactionList,
    clearSearchByDate,
    refreshTable,
  };
};

export default useAccountTransactionsHistoryList;
